import { inject, Pipe, PipeTransform } from '@angular/core'

import { ASSETS_BASE_URL } from '../settings/assets-base-url.token'

/** Схема (`http:`, `data:`, ...) или протокол-относительный URL (`//host/...`). */
const ABSOLUTE_URL_REGEXP = /^([a-z][a-z\d+\-.]*:|\/\/)/i

/**
 * Дописывает {@link ASSETS_BASE_URL} к относительному пути ассета.
 *
 * `{{ 'assets/images/icons/envelope.svg' | bmAssetUrl }}`
 *
 * При пустом значении токена (значение по умолчанию) путь возвращается как есть —
 * поведение приложений, которые токен не переопределяют, не меняется.
 * Абсолютные URL и пути, начинающиеся со слэша, не трогаются.
 */
@Pipe({ name: 'bmAssetUrl' })
export class AssetUrlPipe implements PipeTransform {
  private readonly baseUrl = inject(ASSETS_BASE_URL)

  transform(path: string): string {
    if (!path || !this.baseUrl) {
      return path
    }

    if (path.startsWith('/') || ABSOLUTE_URL_REGEXP.test(path)) {
      return path
    }

    return `${this.baseUrl.replace(/\/+$/, '')}/${path}`
  }
}
